import image from "../assets/images/coin.jpg";
import TopHeader from "../components/TopHeader";
import FaqAccordion from "../components/FaqAccordion";

export default function FAQS() {
  return (
    <section className="font-sans min-h-screen bg-gray-100">
      {/* Banner */}
      <div
        className="relative bg-cover bg-center h-100 items-center flex justify-center "
        style={{ backgroundImage: `url(${image})` }} // replace with real image path
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <TopHeader title="frequently asked questions" subtitle="faqs" />
      </div>
      {/* FAQ Section */}
      <div className="bg-white max-w-6xl mx-auto w-full p-4">
        <FaqAccordion />
      </div>
    </section>
  );
}
